// src/services/themeService.js

class ThemeService {
  constructor() {
    // تهيئة listeners أولاً
    this.listeners = new Set();
    
    this.theme = this.getStoredTheme() || 'light';
    this.applyTheme(this.theme);
  }

  // الحصول على الثيم المخزن في localStorage
  getStoredTheme() {
    try {
      return localStorage.getItem('theme');
    } catch (error) {
      console.error('Error accessing localStorage:', error);
      return 'light';
    }
  }

  // حفظ الثيم في localStorage
  setStoredTheme(theme) {
    try {
      localStorage.setItem('theme', theme);
    } catch (error) {
      console.error('Error saving to localStorage:', error);
    }
  }

  // تطبيق الثيم على document
  applyTheme(theme) {
    this.theme = theme;
    
    // استخدام class بدلاً من data-theme لتتوافق مع Tailwind
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    
    this.setStoredTheme(theme);
    
    // إعلام جميع المستمعين بالتغيير
    this.notifyListeners();
  }

  // تبديل الثيم
  toggleTheme() {
    const newTheme = this.theme === 'light' ? 'dark' : 'light';
    this.applyTheme(newTheme);
    return newTheme;
  }

  // الحصول على الثيم الحالي
  getCurrentTheme() {
    return this.theme;
  }

  // التحقق إذا كان الوضع المظلم مفعلاً
  isDarkMode() {
    return this.theme === 'dark';
  }

  // إضافة مستمع للتغييرات
  addListener(callback) {
    this.listeners.add(callback);
    return () => this.listeners.delete(callback);
  }

  // إخطار جميع المستمعين
  notifyListeners() {
    // تأكد من أن listeners مهيأ
    if (this.listeners) {
      this.listeners.forEach(callback => {
        if (typeof callback === 'function') {
          callback(this.theme);
        }
      });
    }
  }

  // التعامل مع تفضيلات النظام
  watchSystemPreference() {
    // فقط إذا لم يكن هناك تفضيل محفوظ
    if (!this.getStoredTheme()) {
      const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
      
      const handleChange = (e) => {
        const newTheme = e.matches ? 'dark' : 'light';
        this.applyTheme(newTheme);
      };
      
      mediaQuery.addEventListener('change', handleChange);
      handleChange(mediaQuery);
      
      return () => mediaQuery.removeEventListener('change', handleChange);
    }
    
    return () => {}; // دالة تنظيف فارغة
  }
}

// إنشاء نسخة واحدة من الخدمة (Singleton)
const themeService = new ThemeService();

export default themeService;